import i18n from '@/plugins/i18n'

export default {
    path: '/' + i18n.t('reset-password.routes.index') + '/:token',
    name: 'reset-password',
    component: () =>
        import(
            /* webpackChunkName: "reset-password" */ '@/views/auth/ResetPassword.vue'
        ),
    meta: {
        layout: 'simple-layout',
        guest: true,
    },
    props: true,
}
